import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f91a0f70&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f91a0f70')) {
      api.createRecord('f91a0f70', component.options)
    } else {
      api.reload('f91a0f70', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f91a0f70&", function () {
      api.rerender('f91a0f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/changePassword/index.vue"
export default component.exports